module.exports = __webpack_public_path__ + "img/icon_bed.be6aff7b.png";